export const FIELDS_INSTRUCTIONS = {
    CAMPAIGN: {
        NAME: "Enter a short, catchy name that identifies your campaign (Max 100 characters).",
        DESCRIPTION: "Provide a brief overview of your campaign, including purpose, key messages, and target audience.",
        BRAND: "Choose the brand under which this campaign will be launched.",
        STRATEGY: "Choose if you wish to run a barter or a Paid Campaign.",
        BUDGET: "Enter the total budget allocated for this campaign.",
        LAUNCH_DATE: "Select the date when the campaign will go live.",
        INFLUENCER_GENDER: "Select the preferred gender of creators for this campaign.",
        APPLICATION_RESTRICTION: "Set restrictions on who can apply to this campaign.",
        APPLICATION_RESTRICTION_DURATION: "Set duration for the application restriction.",
        INFLUENCER_AGE: "Specify the age range of creators you are looking to work with.",
        AUDIENCE_AGE: "Specify the target audience age for the campaign.",
        INFLUENCER_LOCATION: "Select the locations where creators are based.",
        AUDIENCE_LOCATION: "Specify the target audience locations for the campaign.",
        NICHES: "Select the niches relevant to your campaign.",
        TOPICS: "Select the topics relevant to your campaign.",
        EXCLUDE_TOPICS: "Select the topics not relevant to your campaign.",
        MIN_INSTAGRAM_FOLLOWERS: "Enter the minimum number of Instagram followers required.",
        MIN_AVERAGE_VIEWS: "Enter the minimum number of average views required.",
        INFLUENCER_LANGUAGE: "Select the languages the creator should have content in.",
        PER_INFLUENCER_BUDGET: "Enter the budget you are looking to allocate per creator.",
        AUDIENCE_GENDER: "Specify the target audience gender for the campaign.",
        BARTER_BUDGET: "Enter the value of barter per creator.",
        LANDING_PAGE_URL: "Enter the target link which will be used by creators.",
        CONTENT_MEDIA_TYPES: "Enter the number of reels/posts/stories required for delivery.",
        MODE: "Offline campaign will not accept applications, it will only track posts performance."
    },
    USER: {
        NAME: "Enter the full name of the user you wish to grant access to.",
        EMAIL: "Enter the email address of the user who will receive access and will be notified.",
        ROLE: "Select the user's role to define their access level, \n*Owner:* Full access, including settings and management,\n*Operations:* Limited access for managing campaigns and creators,\n*Viewer:* Read-only access to view campaigns and reports.",
        BRANDS: "Select the brands of which you want to provide access to the user.",
        NOTIFICATION_PREFERENCES: "Select the events you want the user to receive notifications for."
    },
    BRAND: {
        LOGO: "Upload your brand's logo. Recommended size: 500x500 px. Accepted formats: JPG, PNG.",
        NAME: "Enter your brand's name. (Max 50 characters).",
        DESCRIPTION: "Provide a brief description of your brand, including its purpose and target audience.",
        WEBSITE: "Enter your brand's official website URL.",
        INSTAGRAM_HANDLE: "Provide your brand's official Instagram handle."
    },
    MILESTONE: {
        BRIEF: "Give Creators more detail about the product or service you would like to promote. You can include a description with its main features as well as some links.",
        CTA: "Let creators create their own CTAs, or provide a fixed CTA or multiple options to choose from.",   
        SCRIPTS: "You can let the creator create their own script, or you can provide a fixed script or multiple script options for them to choose from.",
        CAPTIONS: "You can let the creator create their own caption, or you can provide a fixed caption or multiple caption options for them to choose from.",
        SCRIPT_SUBMISSION: "Do you want to approve the script after the creator selects or proposes one?",
        CAPTION_SUBMISSION: "Do you want to approve the caption after the creator selects or proposes one?",
        CREATIVES: "Provide creatives for creators to use in their content.",
        SAMPLE_POSTS: "Provide examples of similar content that you like.",
        REIMBURSEMENT_BUDGET: 'Specify the budget that you will pay creator after they purchase these items.',
        GIG_SELECTION: "In this section, you need to define the <GIG>'s availability and select the <GIG> for the creator collaboration.",
        STORE_NAME: "Choose the name as it appears in Google Maps",
        CTA_INFLUENCER: "Let creators choose a CTA of their choice from provided options.",
        DONTS: "Is there anything specific that you don't want the Creator to do?",
        PRODUCT_DELIVERY: "Choose how you want Creators to receive the product"
    }
};
